var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ReportNavigatorService } from '../../services/report-navigator.service';
import { TherapistScaleResultsComponent } from '../therapist-scale-results/therapist-scale-results.component';
import { OnInit, ElementRef } from '@angular/core';
import { PclGraderService } from 'app/reports/services/pcl-grader.service';
var PclAssessmentResultsComponent = /** @class */ (function (_super) {
    __extends(PclAssessmentResultsComponent, _super);
    function PclAssessmentResultsComponent(navigator, el, pclGrader) {
        var _this = _super.call(this, navigator, el) || this;
        _this.pclGrader = pclGrader;
        return _this;
    }
    PclAssessmentResultsComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.AssessmentResult) {
            this._criteria = this.pclGrader.getPCLCriteriaFromAssessmentResult(this.AssessmentResult);
        }
    };
    PclAssessmentResultsComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    PclAssessmentResultsComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    Object.defineProperty(PclAssessmentResultsComponent.prototype, "Criteria", {
        get: function () {
            return this._criteria;
        },
        enumerable: true,
        configurable: true
    });
    return PclAssessmentResultsComponent;
}(TherapistScaleResultsComponent));
export { PclAssessmentResultsComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/pcl-assessment-results/pcl-assessment-results.component.ts.pre-build-optimizer.js